export enum MessageTypesE {
  Undefined = 'Undefined',
  Text = 'Text',
  Action = 'Action',
  ArtifactUpload = 'ArtifactUpload',
  ArtifactDelete = 'ArtifactDelete',
  AttachmentApproval = 'AttachmentApproval',
  ScreenshotUpload = 'ScreenshotUpload',
}

export enum MessageSourcesE {
  ScheduleImport = 'ScheduleImport',
}
